import * as React from "react";
import NotFound from "../../components/Errors/NotFound";
import {useIsRefinitiv} from "../../hooks/refinitiv";

export default ({children}) => {
    const isRefinitiv = useIsRefinitiv();

    if (isRefinitiv) {
        return children
    }

    return <NotFound/>
}